import React, { useEffect, useState } from 'react'
import ToggleSwitch from '../../../Components/ToggleSwitch';
import { default as ReactSelect, components } from "react-select";
import ImageModal from '../../../Components/ImageModal';
import FileUpload from '../../../Components/FileUpload';
import BusyLoader from '../../../Components/BusyLoader';
import { CommonUtil } from '../../../utils/CommonUtil';
import { NetworkManager } from '../../../Components/NetworkManager';
import ToastManager from '../../../Components/ToastManager';
import { Constants } from '../../Languages/Constants';
import { StatusCodeUtil } from '../../../utils/StatusCodeUtil';
import Confirm from '../../../Components/confirm';

const DescriptionPicture = ({processType, onDataChange, isEdit, eData, processTypeData}: any) => {
  const [pictureMarkedValue, setPictureMarkedValue] = useState<any>([]);
  const [descriptionMarkedValue, setDescriptionMarkedValue] = useState<any>([]);
  const [galleryPop, setGalleryPop] = useState(false);
  const [imageFiles, setImageFiles] = useState<any>({});
  const [imageSrc, setImageSrc] = useState<any>("");
  const [isValid, setIsValid] = useState<any>(false);
  const [toggles, setToggles] = useState<any>({
    isDescriptionMandatory: false,
    isTaskDescriptionMarked: false,
    assistedPictureRequired: false,
    isMultiPicture: false,
    isPictureMandatory: false,
    isTaskPictureMarked: false,
  });
  
  let imgName = '';
  let imgPath = '';
  let uploadType = '';
  let fileData = {};
  
  useEffect(() => {
    if (toggles?.assistedPictureRequired === false) {
      setImageFiles({});
      setImageSrc("");
    }
  }
  , [toggles?.assistedPictureRequired]);

  useEffect(() => {
    if (isEdit === "task" && eData) {
      if(eData?.processType){
        const pictureMarked = eData?.pictureMarkedValue?.map((item: any) => {
          return { label: item, value: item }});
        const descriptionMarked = eData?.descriptionMarkedValue?.map((item: any) => {
          return { label: item, value: item }});
        setPictureMarkedValue((prev: any) => (prev !== pictureMarked ? pictureMarked || [] : prev));
        setDescriptionMarkedValue((prev: any) => (prev !== descriptionMarked ? descriptionMarked || [] : prev));
        setImageFiles((prev: any) => (
          prev?.path !== eData.assistedPicturePath
            ? {
                name: eData.assistedPictureName || '',
                path: eData.assistedPicturePath || '',
              }
            : prev
        ));
        if (eData.assistedPicturePath) {
          var qParam: string = `objectPath=${eData.assistedPicturePath}`
          NetworkManager.sendJsonRequest('api/session/downloadUrl', '', qParam, 'GET', true, (data: any) => {
            console.log(data, "data")
            setImageSrc(data)
          }, onLoginError);
        }
      }
      setToggles((prevToggles: any) => {
        const newToggles = {
          assistedPictureRequired: eData?.assistedPictureRequired || false,
          isDescriptionMandatory: eData?.isDescriptionMandatory || false,
          isTaskDescriptionMarked: eData?.isTaskDescriptionMarked || false,
          isMultiPicture: eData?.isMultiPicture || false,
          isPictureMandatory: eData?.isPictureMandatory || false,
          isTaskPictureMarked: eData?.isTaskPictureMarked || false,
        };
  
        if (JSON.stringify(prevToggles) === JSON.stringify(newToggles)) {
          return prevToggles;
        }
        return newToggles;
      });
    }
  }, [isEdit, eData]);
  
  useEffect(() => {
    const data = {
      ...toggles,
      pictureMarkedValue,
      descriptionMarkedValue,
      imageFiles,
    }
    onDataChange(data);
  }, [toggles, pictureMarkedValue, descriptionMarkedValue, imageFiles]);

  useEffect(() => {
    let isValid = true;

    if (toggles.assistedPictureRequired && !imageSrc) {
      isValid = false;
    }

    if (toggles.isTaskPictureMarked && pictureMarkedValue.length === 0) {
      isValid = false;
    }
    
    if (toggles.isTaskDescriptionMarked && descriptionMarkedValue.length === 0) {
      isValid = false;
    }

    setIsValid(isValid);

    if (!toggles.isTaskPictureMarked && pictureMarkedValue.length > 0) {
      setPictureMarkedValue([]);
    }

    if (!toggles.isTaskDescriptionMarked && descriptionMarkedValue.length > 0) {
      setDescriptionMarkedValue([]);
    }

  }, [
    toggles.assistedPictureRequired,
    toggles.isTaskPictureMarked,
    toggles.isTaskDescriptionMarked,
    imageSrc,
    pictureMarkedValue,
    descriptionMarkedValue
  ]);

  useEffect(() => {
    const data = {
      ...toggles,
      pictureMarkedValue,
      descriptionMarkedValue,
      imageFiles,
      isValid
    }
    onDataChange(data);
  }, [toggles, pictureMarkedValue, descriptionMarkedValue, imageFiles, isValid]);

  const onLoginError = (err: any) => {
    console.log(err);
  };

  const handleToggleChange = (key: string, value: boolean) => {
    setToggles((prevState:any) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const onUpload = (files: any) => {
    if (files) {
      fileData = files;
    }
    console.log("fileData", fileData);
    imgName = files?.name;
    uploadType = "image"

    var oFReader = new FileReader()
    oFReader.readAsDataURL(files)
    oFReader.onload = function (oFREvent) {
    setImageSrc(oFREvent.target?.result)
    BusyLoader.showLoader();
      imgPath = `interchange/task/image/${CommonUtil.getSelectedOrgId()}/${imgName}-${new Date().getTime()}`;
      setImageFiles({...imageFiles, name: imgName, path: imgPath})
      var qParam: string = `objectPath=${imgPath}`;
      NetworkManager.sendJsonRequest("api/session/uploadUrl", "", qParam, "GET", false, onUploadSuccess, onLoginError);
    }
  };

  const onUploadSuccess = (dataObj: any) => {
    if (dataObj) {
      if (dataObj.statusCode) {
        BusyLoader.hideLoader();
        ToastManager.showToast(dataObj.errorMessage, "Error");
      }else{
        var strUploadPath = dataObj;
        if ((imgName) !== '') {
          var myHeaders = new Headers();
          var requestOptions: any = {
            method: "PUT",
            headers: myHeaders,
            body: fileData,
            redirect: "follow",
          };
          fetch(strUploadPath, requestOptions)
            .then((response) => response.text())
            .then((result) => {
              BusyLoader.hideLoader();
              updateOrgLogo();
            })
            .catch((error) => {
              BusyLoader.hideLoader();
              console.log("error", error);
            });
        }
      }
    }
  };

  let updateOrgLogo = () => {
    if (fileData) {
      var qParam: string = 'logoPath=interchange/task/image/' + imgName + '&saasOrgId=' + CommonUtil.getSaasOrgId();
      NetworkManager.sendJsonRequest('api/organization/updateOrganizationLogo', '', qParam, 'PUT', false, onUpdateOrgLogoSuccess, onLoginError);
    }
  }

  let onUpdateOrgLogoSuccess = (dataObj: any) => {
    BusyLoader.hideLoader()
    let strInfo = CommonUtil.getMessageText(Constants.INFO,"Info");
    let strError = CommonUtil.getMessageText(Constants.ERROR,"Error");
    let strLogoUpdated = CommonUtil.getMessageText(Constants.LOGO_UPDATED,"Logo updated successfully");
    if (dataObj) {
      var restData = JSON.parse(dataObj)
      if (restData.statusCode) {
        BusyLoader.hideLoader()
        var errMsg = StatusCodeUtil.getCodeMessage(restData.statusCode)
        ToastManager.showToast(errMsg, strError)
      } else {
        ToastManager.showToast(strLogoUpdated, strInfo)
      }
      
      imgName = '';
      uploadType = '';
      imgPath = '';
      fileData = {};
      setImageFiles({});
    } else {
      ToastManager.showToast(strLogoUpdated, strInfo)
    }
  }

  const removeFile = (fileType: any) => {
    Confirm.show("Confirm", "Would you like to delete this file?", [
      {
        label: "Yes",
        callback: function () {
          if(fileType == "image"){
            setImageSrc("");
            setImageFiles({});
          }
          ToastManager.showToast("File Removed", "Info");
        },
      },
      { label: "No" },
    ]);
  };

  return (
    <div className="row ms-1">
      <div className="row">
        {processType !== "CTPAT" && (<div className="bg-gray p-3">
          <label>Pictures</label>
          <div className="col-md-12">
            <div className='row'>
            <div className='col-md-12'>
            <ToggleSwitch
            checked={toggles.isPictureMandatory}
            onChange={(value :any) => handleToggleChange("isPictureMandatory", value)}
            label="Is Picture mandatory?"
            />
            <ToggleSwitch
            checked={toggles.isMultiPicture}
            onChange={(value :any) => handleToggleChange("isMultiPicture", value)}
            label="Multiple pictures supported?"
            />
            {processType === "General" &&
            <div className="d-flex justify-content-start align-items-center">
              <div>
                <ToggleSwitch
                  checked={toggles.isTaskPictureMarked}
                  onChange={(value :any) => handleToggleChange("isTaskPictureMarked", value)}
                  label="Picture required when a task is marked"
                />
              </div>
              <div className='ms-3'>
                <ReactSelect
                  name="pictureMarkedValue"
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ MultiValue: CustomMultiValue, DropdownIndicator: CustomDropdownIndicator, Option: CustomOption }}
                  options={ [...processTypeData?.multiStatus]}
                  value={pictureMarkedValue}
                  onChange={(selected) => setPictureMarkedValue(selected)}
                  isDisabled={!toggles.isTaskPictureMarked}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      minHeight: "18px",
                      minWidth: "280px",
                    }),
                  }}
                />
                {toggles.isTaskPictureMarked && pictureMarkedValue.length === 0 && (
                  <small className="fst-italic text-danger ms-2 fw-700">Picture marked value is required</small>
                )}
              </div>
            </div>}
            <div className="d-flex mt-1">
              <div>
                <ToggleSwitch
                  checked={toggles.assistedPictureRequired}
                  onChange={(value :any) => handleToggleChange("assistedPictureRequired", value)}
                  label="Is an assisted picture required?"
                />
              </div>
              <div className={`d-flex mt-2`}>
                <div className=" ms-3 me-2">
                  <FileUpload 
                    imageUpload
                    acceptedFileTypes={['.png', '.jpg', '.jpeg']}
                    maxFileSize={5 * 1024 * 1024}
                    onFileUpload={onUpload}
                    isDisabled={!toggles.assistedPictureRequired}
                  />
                {toggles.assistedPictureRequired && !imageSrc && (
                  <small className="fst-italic text-danger ms-1 fw-700">Assisted picture is required</small>
                )}
                </div>
                <div className={`${toggles.assistedPictureRequired ? "" : "d-none"} px-3`}>
                {(imageSrc || imageFiles.name) && (
                  <div role='button'>
                    <div className="d-inline-block position-relative" style={{width: "200px"}}>
                      <img
                        src={imageSrc}
                        width={200}
                        height={100}
                        className='border'
                        alt={imageFiles.name}
                        title={imageFiles.name}
                        onClick={(e: any) => {
                          setGalleryPop(true);
                        }}
                      />
                      <button
                        type="button"
                        title="Delete"
                        className="img-close-btn"
                        onClick={() => removeFile("image")}
                      >
                        <img src={"./../images/cancel.svg"} alt="cancel" width={12} height={12} />
                      </button>
                    </div>
                    </div>)}
                </div>
              </div>
            </div>
            </div>
            </div>
            </div>
        </div>)}
      </div>
      <div className="row">
        <div className="col-md-12 my-2 g-0">
          <div className="bg-gray p-3">
            <label>Description</label>
            <ToggleSwitch
              checked={toggles.isDescriptionMandatory}
              onChange={(value: any) => handleToggleChange("isDescriptionMandatory", value)}
              label="Is Description mandatory?"
            />
            {["General", "Light", "Reefer", "Tire and Brakes"].includes(processType) && 
            <div className="d-flex justify-content-start align-items-center">
              <div>
                <ToggleSwitch
                checked={toggles.isTaskDescriptionMarked}
                onChange={(value :any) => handleToggleChange("isTaskDescriptionMarked", value)}
                label="Description required when a task is marked"
                />
              </div>
              <div className='ms-3'>
                <ReactSelect
                  name="descriptionMarkedValue"
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ MultiValue: CustomMultiValue, DropdownIndicator: CustomDropdownIndicator, Option: CustomOption }}
                  options={ [...processTypeData?.multiStatus]}
                  value={descriptionMarkedValue}
                  onChange={(selected) => setDescriptionMarkedValue(selected)}
                  isDisabled={!toggles.isTaskDescriptionMarked}
                  styles={{
                    control: (provided: any) => ({
                      ...provided,
                      minHeight: "18px",
                      minWidth: "255px"
                    }),
                  }}
                />
                {toggles.isTaskDescriptionMarked && descriptionMarkedValue.length === 0 && (
                  <small className="fst-italic text-danger ms-2 fw-700">Description marked value is required</small>
                )}
              </div>
            </div>}
          </div>
        </div>
      </div>
      {galleryPop && ( 
        <ImageModal
        isOpen={galleryPop}
        imageSrcs={[imageSrc]}
        caption={imageFiles?.name}
        onClose={() => setGalleryPop(false)}
      />)}
    </div>
  )
}

const CustomDropdownIndicator = () => null;

const CustomMultiValue = ({ data, index, selectProps }: any) => {
  const selectedValues = selectProps.value || [];
  if (index !== 0) return null;

  const visibleCount = 3;
  const visibleLabels = selectedValues.slice(0, visibleCount).map((item: any) => item.label);
  const remainingCount = selectedValues.length - visibleCount;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
      <span>{visibleLabels.join(",  ")}</span>
      {remainingCount > 0 && (
        <span className="count-badge" style={{ marginLeft: 5 }}>
          +{remainingCount}
        </span>
      )}
    </div>
  );
};

const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
      />
      <label style={{ marginLeft: "8px" }}>{props.label}</label>
    </components.Option>
  );
};
export default DescriptionPicture